/**
 * Images to be displayed within the app.
 *
 * Given an image id to correlate with the image to display in the viewer
 */
export type AppDisplayImage<TImage> = {
    imageId: string;
} & TImage;

/**
 * Images to be displayed within the viewer.
 */
export type ViewerImage = {
    uri: string;
    description?: string;
    imageFetchUrl: string;
    imageId: string;
};

export type RenderImagesData<TImage> = {
    viewerImages: ViewerImage[];
    appDisplayImages: AppDisplayImage<TImage>[];
    imageIndex: number;
    isOpen: boolean;
    onClose: () => void;
    getIsPressEnabled: (image: AppDisplayImage<TImage>) => boolean;
    onPress: (image: AppDisplayImage<TImage>) => void;
};
